import { createSelector } from '@ngrx/store';
import { IRootState } from '../../../root';
import { IIntroductionState } from './introduction.state';

export class IntroductionSelectors {
  // todo: replace any type state with root state (once defined)
  static readonly introductionState = (state: IRootState): IIntroductionState => {
    return state.introduction as IIntroductionState;
  };

  static readonly model = createSelector(
    IntroductionSelectors.introductionState,
    (introduction: IIntroductionState) => {
      return introduction.model;
    }
  );

  static readonly data = createSelector(IntroductionSelectors.introductionState, (introduction: IIntroductionState) => {
    return introduction.data;
  });
}
